import { commonComponents as cc } from "@/components/common";
import { services as s } from "@/services";
import type {
	ExtendedTrackerViewT,
	StatefulTrackerViewT,
} from "@/types/database/trackers";

import { Copy } from "@/components/common/Copy";
import type { SharedAttributeJSON } from "@/features/shared_attributes/types";
import { useAuth } from "@/utils/auth";
import { useDiaryByIdQuery } from "../../diaries/api";
import EditInjectionAsPatient from "../../injection/components/EditInjectionAsPatient";
import useIsMyDiary from "../../patients/hooks/useIsMyDiary";
import SharedAttributeContactPerson from "../../shared_attributes/components/SharedAttributeContactPerson";
import SharedAttributeDatePicker from "../../shared_attributes/components/SharedAttributeDatePicker";
import SharedAttributeHospitalNumberForm from "../../shared_attributes/components/SharedAttributeHospitalNumberForm";
import TrackerNameForm from "./TrackerNameForm";

interface Props {
	tracker: StatefulTrackerViewT | ExtendedTrackerViewT;
}

const EditTracker = ({ tracker }: Props) => {
	const auth = useAuth();
	const { data: diary } = useDiaryByIdQuery(tracker.diary_id as string);

	const { isMyDiary } = useIsMyDiary(tracker.diary_id as string);

	if (!tracker || !diary) {
		return <p>No Tracker</p>;
	}

	const sharedAttributes =
		diary.shared_attributes as SharedAttributeJSON | null;

	return (
		<>
			<cc.EditDialog
				label="Name"
				description="The name of this intervention"
				info={tracker.tracker_name}
				noInfo={!tracker.tracker_name}
			>
				<TrackerNameForm
					diaryId={tracker.diary_id}
					trackerId={tracker.tracker_id}
				/>
			</cc.EditDialog>

			<cc.EditDialog
				label="Start Date"
				info={s.time.formatShortDateTime(tracker.start_date)}
				noInfo={!tracker.start_date}
			>
				<SharedAttributeDatePicker
					dateType="start_date"
					sharedAttributes={sharedAttributes}
				/>
			</cc.EditDialog>

			<cc.EditDialog
				label="Reference Date"
				info={s.time.formatShortDateTime(tracker.reference_date)}
				noInfo={!tracker.reference_date}
			>
				<SharedAttributeDatePicker
					dateType="reference_date"
					sharedAttributes={sharedAttributes}
				/>
			</cc.EditDialog>

			{/* <cc.EditDialog
				label="Hospital Number"
				info={tracker.hospital_number}
				noInfo={!tracker.hospital_number}
			>
				<SharedAttributeHospitalNumberForm
					initialHospitalNumber={tracker.hospital_number}
					sharedAttributes={sharedAttributes}
				/>
			</cc.EditDialog>

			<cc.EditDialog
				locked={!auth.roles?.isClinician}
				label="Contact Person"
				noInfo={!tracker.contact_email}
				info={
					tracker.contact_email ? (
						<Copy
							id="contact-person"
							value={tracker.contact_email ?? ""}
							className="w-full"
						>
							{tracker.contact_email}
						</Copy>
					) : (
						"Contact Person Missing"
					)
				}
			>
				<SharedAttributeContactPerson
					sharedAttributes={sharedAttributes}
					initialContactId={sharedAttributes?.contact_id}
					organisationId={diary.organisation_id ?? ""}
				/>
			</cc.EditDialog> */}

			{isMyDiary &&
				diary.events_view
					.filter((e) =>
						tracker.events?.map((ev) => ev.event_id)?.includes(e.event_id),
					)
					.map((e) =>
						e.injections_view.map((iv) => (
							<EditInjectionAsPatient
								diaryId={tracker.diary_id as string}
								injection={iv}
								key={iv.injection_id}
							/>
						)),
					)}
		</>
	);
};

export default EditTracker;
